import React from 'react';
import CanWeHelpImg from "../../images/can we help.png";
import LinkedInImg from "../../images/linkidn.svg";
import FacebookImg from "../../images/fb.svg";
import InstagramImg from "../../images/instagram.svg";
import YoutubeImg from "../../images/youtube.svg";
import LeoCussenLogo from "../../images/Leo Cussen Logo-footer.svg";
import Ctabg from '../../images/contact-bg.jpg';
import CTASection from '../Sections/CTASection';

export const Footer = (props) => {

  return (
    <>
      {/* CTA + footer share one background so the image continues behind the
          footer (no cream gap) — matches the main site's footer-cta wrapper. */}
      <div className="footer_cta_group" style={{ backgroundImage: "url(" + Ctabg + ")" }}>
      <CTASection EngineURL={props.EngineURL} />

      <footer className="footer_new" role="contentinfo">

        {/* Floating help button */}
        <div className='can_we_help_button' onClick={() => props.setCanWeHelpStatus(true)}>
          <img src={CanWeHelpImg} alt="Can We Help" className='d-lg-none' />
          <span className='d-none d-lg-block'>Can we help ?</span>
        </div>

        <div className='footer_new_inner'>

          {/* ── Top: brand (logo + social) on the left, nav columns on the right ── */}
          <div className='footer_new_main'>
            <div className='footer_new_brand'>
              <a href="/" className='footer_new_logo'>
                <img src={LeoCussenLogo} alt="Leo Cussen Centre for Law" />
              </a>
              <div className='footer_new_social'>
                <a href="https://www.linkedin.com/school/leo-cussen-centre-for-law" target="_blank" rel="noreferrer"><img src={LinkedInImg} alt="LinkedIn" /></a>
                <a href="https://www.facebook.com/leocussencentreforlaw" target="_blank" rel="noreferrer"><img src={FacebookImg} alt="Facebook" /></a>
                <a href="https://www.instagram.com/leocussen/" target="_blank" rel="noreferrer"><img src={InstagramImg} alt="Instagram" /></a>
                <a href="https://www.youtube.com/@leocussencentreforlaw" target="_blank" rel="noreferrer"><img src={YoutubeImg} alt="YouTube" /></a>
              </div>
            </div>

            <div className='footer_new_nav'>
              <div className='footer_new_col'>
                <span className='footer_new_col_heading'>Company</span>
                <nav>
                  <a href="https://www.leocussen.edu.au/about-us/" target="_blank" rel="noreferrer">About us</a>
                  <a href="https://www.leocussen.edu.au/venue-hire/" target="_blank" rel="noreferrer">Venue Hire</a>
                  <a href="https://www.leocussen.edu.au/contact/" target="_blank" rel="noreferrer">Contact</a>
                  <a href="https://www.leocussen.edu.au/contact/locations/" target="_blank" rel="noreferrer">Locations</a>
                </nav>
              </div>
              <div className='footer_new_col'>
                <span className='footer_new_col_heading'>Policies and procedures</span>
                <nav>
                  <a href="https://www.leocussen.edu.au/policies/" target="_blank" rel="noreferrer">Policies and procedures</a>
                  <a href="https://www.leocussen.edu.au/copyright/" target="_blank" rel="noreferrer">Copyright</a>
                </nav>
              </div>
            </div>
          </div>

          {/* ── Bottom bar: copyright + acknowledgment + attribution ── */}
          <div className='footer_new_bar2'>
            <div className='footer_new_bar2_left'>
              <p className='footer_new_copyright'>
                © 2026 Leo Cussen Institute trading as Leo Cussen Centre for Law. All Rights Reserved. ABN: <strong>16 949 282 178</strong> CRICOS Providing Number: <strong>02224A</strong>
              </p>
              <p className='footer_new_acknowledgment'>
                Leo Cussen Centre for Law acknowledges the Traditional Custodians of Country throughout Australia and their connections to land, sea and community. We pay our respects to their Elders past and present and extend that respect to all Aboriginal and Torres Strait Islander peoples today.
              </p>
            </div>
            <p className='footer_new_attribution'>Designed by Bone, built by <a href="https://saltandfuessel.com.au/" target="_blank" rel="noopener noreferrer">Salt &amp; Fuessel</a></p>
          </div>

        </div>

      </footer>
      </div>
    </>
  );
};

export default Footer;
